import adproductsUtils from 'app/shared/utils/adproductsUtils';
import AdproductsConstants from 'app/shared/constants/AdproductsConstants';

const { FlatFeeTypes } = AdproductsConstants;

const PRODUCT_TYPES = {
    FLAT_FEE: 'FLAT_FEE',
    PAY_PER_CLICK: 'PAY_PER_CLICK',
    PAY_PER_LEAD: 'PAY_PER_LEAD',
    PAY_PER_LEASE: 'PAY_PER_LEASE',
    SINGLE_FAMILY_DAILY_LISTINGS: 'SINGLE_FAMILY_DAILY_LISTINGS',
};

const CoreProductInvoiceListing = ({
    feedListingId = '',
    feedId = '',
    billableClickCount = 0,
    leaseCount = 0,
    waitlistCost = 0,
    coreProductCost = 0,
    totalCost = 0,
    waitlistedDays = 0,
    boostCost = 0,
    numEmailLeads = 0,
    numPhoneLeads = 0,
    activeDays = 0,
    dailyRate = 0,
    adproductTypes = [],
    unitName = '',
    insertionOrderId = '',
    singleFamilyLegacy = 0,
} = {}) => ({
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    billableClickCount: Number(billableClickCount),
    leaseCount: Number(leaseCount),
    waitlistCost: Number(waitlistCost),
    totalCost: Number(totalCost),
    waitlistedDays: Number(waitlistedDays),
    coreProductCost: Number(coreProductCost),
    singleFamilyLegacy: Number(singleFamilyLegacy),
    boostCost: Number(boostCost),
    numEmailLeads: Number(numEmailLeads),
    numPhoneLeads: Number(numPhoneLeads),
    activeDays: Number(activeDays),
    dailyRate: Number(dailyRate),
    isClickProduct: adproductTypes.some(type => type === PRODUCT_TYPES.PAY_PER_CLICK),
    isLeadProduct: adproductTypes.some(type => type === PRODUCT_TYPES.PAY_PER_LEAD),
    isLeaseProduct: adproductTypes.some(type => type === PRODUCT_TYPES.PAY_PER_LEASE),
    isFlatFeeProduct: adproductTypes.some(type => FlatFeeTypes.has(type)),
    isRocketship: adproductTypes.some(type => type === PRODUCT_TYPES.SINGLE_FAMILY_DAILY_LISTINGS),
    unitName: String(unitName),
    adproductTypes: adproductsUtils.mapProductTypes(adproductTypes),
    adproductCodes: adproductTypes,
    insertionOrderId: String(insertionOrderId),
});

export default CoreProductInvoiceListing;
